<template>
    <div style="display: flex; flex-direction: row; gap: 10pt">
        <md-switch v-model="enabled" class="md-primary" style="margin: auto;">{{ title  }} [{{ name }}]</md-switch>

        <md-chips class="md-primary"  style="flex: 1 0 0" :style="`opacity: ${enabled? 1: 0}`" v-model="foreCastHours" @input="input" md-placeholder="Stunden (1-24)" :md-auto-insert="true" md-input-type="number" :md-format="formatInput">
            <label>Vorhersage von 1-24h</label>
            <div class="md-helper-text"></div>
        </md-chips>
    </div>
</template>
<script>

export default{
    name: 'forecast-chips',
    props: {
        title: String,
        name: String,
        value: Array
    },
    computed:{
        getValueNames(){
            if(!this.enabled){
                return []
            }

            return [`now-${this.name}`, ...this.foreCastHours.map(e => `${e}-${this.name}`)]
        },

    },
    methods:{
        formatInput(input){
            if(1 > input || input > 24){
                return ''
            }

            return `forecast${input}h`
        },
        decodeForeCasts(list){
            if((!list) || list.length == 0){
                this.enabled = false;
                this.foreCastHours = []
                return
            }

             // redex combining name with forecastxh-${name}
            const regex = new RegExp(`forecast(\\d+)h-${this.name}`);

            // filter function 
            this.enabled = true;

            
            this.foreCastHours = list.filter(e => e != `now-${this.name}`).reduce((arr, e) => {
                const match = e.match(regex);
                
                if(match && match.length){
                    
                    arr.push(this.formatInput(Number(match[1])))
                }

                return arr
            }, [])  
        },
        input(){
           
            this.$emit('input', this.getValueNames)
            
        }

    },
    watch:{
        value(){
            this.decodeForeCasts(this.value)
        },
        enabled(){
            this.$emit('input', this.getValueNames)
        },
    },
    data(){


        return {
            enabled: false,
            foreCastHours: []
        }
    },
    mounted(){
         this.decodeForeCasts(this.$props.value)

    }
}
</script>